import { Link } from "react-router-dom";
import { JOIN_PATH } from "@/config";

// "Join the Waitlist" button. Navigates in the SAME TAB to this site's own
// /join experience (which talks to the existing Source2Table production API).
export const WaitlistButton = ({
  testid,
  label = "Join the Waitlist",
  variant = "solid",
  className = "",
}) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full font-sans font-semibold tracking-wide transition-transform duration-200 hover:scale-105 active:scale-95 focus:outline-none focus-visible:ring-4 focus-visible:ring-[#4A6B41]/30";

  const variants = {
    solid:
      "bg-[#4A6B41] text-[#F9F6F0] px-7 py-3 text-sm sm:text-base shadow-lg shadow-[#4A6B41]/20 hover:bg-[#2F4829]",
    light:
      "bg-[#F9F6F0] text-[#2F4829] px-7 py-3 text-sm sm:text-base shadow-lg hover:bg-white",
    accent:
      "bg-[#C86D51] text-[#F9F6F0] px-8 py-4 text-base sm:text-lg shadow-xl shadow-[#C86D51]/25 hover:bg-[#b65d43]",
    ghost:
      "bg-transparent text-[#2F4829] px-5 py-2 text-sm border border-[#4A6B41]/30 hover:bg-[#4A6B41]/10",
  };

  return (
    <Link
      data-testid={testid}
      to={JOIN_PATH}
      className={`${base} ${variants[variant]} ${className}`}
    >
      {label}
    </Link>
  );
};
